import { getCountryListRequest } from "@common";
import { Action } from "redux";
import { combineReducersPartial } from "../reducer-factory";
import { chartDataReducer } from "./charts";
import { downloadReducer } from "./download";
import {
    defaultReportState,
    reportParametersForm,
    ReportState,
    defaultGeographicReportState,
    GeographicReportState
} from "./state";
import { putCountrySvgToStoreAction } from "./actions";

const geographicReportReducer = (state = defaultGeographicReportState, action: Action): GeographicReportState => {
    if (putCountrySvgToStoreAction.is(action)) {
        return {
            ...state,
            countrySVGs: {
                ...state.countrySVGs,
                [action.countryIsoCode]: action.countrySVG
            }
        };
    }

    return state;
};

export const reportsReducer = combineReducersPartial<ReportState>(
    {
        form: reportParametersForm.reducer,
        countries: getCountryListRequest.reducer,
        chartData: chartDataReducer,
        downloadState: downloadReducer,
        geographicReport: geographicReportReducer
    },
    defaultReportState
);
